import {
  SET_TOKEN,
  SET_IS_AUTH,
  SET_REFRESH_AUTH,
  SET_ACCOUNT_INFO,
  SET_EXPIRED_AT,
} from "./types";

export default {
  [SET_TOKEN](state, token) {
    state.token = token;
  },
  [SET_IS_AUTH](state, status) {
    state.accountLogin.isAuth = status; // success or fail
  },
  [SET_REFRESH_AUTH](state) {
    (state.accountLogin = {
      isAuth: "fail",
      info: {},
    }),
      (state.token = null);
    state.expired_at = null;
  },
  [SET_ACCOUNT_INFO](
    state,
    { account_code, account_id, first_name, last_name }
  ) {
    state.accountLogin.info = {
      account_id,
      account_code,
      first_name,
      last_name,
    };
  },
  [SET_EXPIRED_AT](state, miliseconds) {
    state.expired_at = miliseconds;
  },
};
